import React from 'react';
import { ShieldAlert, Home } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

export const Forbidden403: React.FC = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-[80vh] flex flex-col items-center justify-center p-6 text-center bg-slate-50">
      <div className="w-20 h-20 rounded-full bg-rose-100 border border-rose-200 flex items-center justify-center mb-6 text-rose-600 animate-pulse">
        <ShieldAlert className="w-10 h-10" />
      </div>

      <h1 className="text-4xl font-extrabold text-slate-900 tracking-tight mb-2">
        403 - Access Denied
      </h1>
      <p className="text-slate-600 max-w-md mb-8 text-sm sm:text-base leading-relaxed">
        You do not have the required permissions to access this page or module. Please contact your system administrator to request access.
      </p>

      <div className="flex items-center gap-3">
        {/* <button
          onClick={() => navigate(-1)}
          className="px-4 py-2.5 rounded-xl border border-slate-300 text-slate-700 text-sm font-semibold hover:bg-slate-100 transition flex items-center gap-2"
        >
          <ArrowLeft className="w-4 h-4" /> Go Back
        </button> */}
        <button
          onClick={() => navigate('/dashboard')}
          className="px-4 py-2.5 rounded-xl bg-[#C1272D] text-white text-sm font-bold cursor-pointer transition flex items-center gap-2"
        >
          <Home className="w-4 h-4" /> Return to Dashboard
        </button>
      </div>
    </div>
  );
};

export default Forbidden403;
